import * as types from "../../constants/index"
import api from "../../api"

export default {
  state: {
    videoListData: {
      data: {},
      status: ""
    },
    videoBoxStatus: false, // 视频列表弹窗状态
    currentVideoUrl: "", // 当前播放视频地址
    videoElem: null, // video htmlElement,
    isPlayingVideo:1    // 1.为动态课件，2位课中视频，3位屏幕共享
  },
  actions: {
    async getVideoList({ dispatch, commit, rootGetters }, payload) {
      commit(types.GET_VIDEO_LIST)
      let { onlineClassId, lessonId } = rootGetters.roomDetail.data
      await api
        .getVideoList({ onlineClassId, lessonId })
        .then(res => {
          commit(types.GET_VIDEO_LIST_SUCCESS, res)
        })
        .catch(error => {
          commit(types.GET_VIDEO_LIST_FAILED, { msg: error })
        })
    }
  },
  mutations: {
    [types.GET_VIDEO_LIST](state, payload) {
      state.videoListData = Object.assign({}, state.videoListData, {
        data: {},
        status: types.GET_VIDEO_LIST
      })
    },
    [types.GET_VIDEO_LIST_SUCCESS](state, payload) {
      state.videoListData = Object.assign({}, state.videoListData, {
        data: payload,
        status: types.GET_VIDEO_LIST_SUCCESS
      })
    },
    [types.GET_VIDEO_LIST_FAILED](state, payload) {
      state.videoListData = Object.assign({}, state.videoListData, {
        data: payload,
        status: types.GET_VIDEO_LIST_FAILED
      })
    },
    [types.SET_VIDEO_URL](state, payload) {
      state.currentVideoUrl = payload
    },
    [types.SET_VIDEO_BOX_STATUS](state, payload) {
      state.videoBoxStatus = payload
    },
    [types.SET_VIDEO_ELEMENT](state, payload) {
      state.videoElem = payload
    },
    [types.SET_VIDEO_STATUS](state, payload) {
      state.isPlayingVideo = payload
    }
  },
  getters: {
    videoList: state => {
      return state.videoListData.data.list || []
    },
    currentVideoUrl: state => state.currentVideoUrl,
    videoBoxStatus: state => state.videoBoxStatus,
    videoElem: state => state.videoElem,
    videoStatus: state => state.videoStatus,
    isPlayingVideo: state => state.isPlayingVideo
  }
}
